import { useEffect, useState } from "react";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { InquiriesData } from "../../../../../components/tables/inquiries-tables/Inquiries";
import { getAllInquiries } from "../../../../../API/Mediatheque/Inquiries/inquirieService";

const breadcrumbItems = [
  {
    title: "Enquêtes publiques",
    link: "/admin-dashboard/mediatheque/enquetes-publiques",
  },
];
export default function Inquiries() {
  const [inquiries, setInquiries] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllInquiries();
    setInquiries(response?.inquiries);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <InquiriesData data={inquiries} />
        </div>
      </div>
    </>
  );
}
